"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRuleModality = applyRuleModality;
const derive_rule_modality_1 = require("./derive-rule-modality");
const implementation_rules_1 = require("./implementation-rules");
function applyRuleModality(text, modality) {
    const collapsed = text.replace(/\bnot\s+not\b/gi, 'not');
    const phrase = phraseFor(modality);
    const targetRank = rankOf(modality);
    const occurrences = [...collapsed.matchAll(modalPhrasePattern())].map((match) => ({
        index: match.index ?? 0,
        original: match[0],
        rank: rankOf(modalityOf(match[0])),
    }));
    if (occurrences.length === 0) {
        const trimmed = collapsed.trim();
        const body = trimmed === '' ? '' : ` ${trimmed.charAt(0).toLowerCase()}${trimmed.slice(1)}`;
        return /^ not\b/i.test(body) ? `The design ${phrase}:${body}` : `The design ${phrase}${body}`;
    }
    const governingRank = Math.min(...occurrences.map((occurrence) => occurrence.rank));
    const governing = occurrences.find((occurrence) => occurrence.rank === governingRank);
    let rewritten = '';
    let cursor = 0;
    for (const occurrence of occurrences) {
        rewritten += collapsed.slice(cursor, occurrence.index);
        const replace = occurrence === governing || occurrence.rank < targetRank;
        rewritten += replace ? matchFirstLetterCase(phrase, occurrence.original) : occurrence.original;
        cursor = occurrence.index + occurrence.original.length;
    }
    return rewritten + collapsed.slice(cursor);
}
function modalPhrasePattern() {
    return new RegExp(`\\b(${(0, derive_rule_modality_1.modalPhrases)()
        .map(({ phrase }) => phrase)
        .join('|')})\\b`, 'gi');
}
function phraseFor(modality) {
    return (0, derive_rule_modality_1.modalPhrases)()[rankOf(modality)].phrase;
}
function rankOf(modality) {
    return (0, derive_rule_modality_1.modalPhrases)().findIndex((candidate) => candidate.modality === modality);
}
function modalityOf(phrase) {
    const normalized = phrase.toLowerCase();
    return (0, derive_rule_modality_1.modalPhrases)().find((candidate) => candidate.phrase === normalized)?.modality ?? implementation_rules_1.RuleModality.Must;
}
function matchFirstLetterCase(phrase, original) {
    const first = original.charAt(0);
    return first === first.toUpperCase() ? `${phrase.charAt(0).toUpperCase()}${phrase.slice(1)}` : phrase;
}
//# sourceMappingURL=rewrite-rule-modality.js.map